import { render } from "./App.vue?vue&type=template&id=42f8cbe0"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=42f8cbe0&lang=scss"

import exportComponent from "/Users/matthew/Documents/Vault/code/sal/backspot/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__